import { useEffect } from 'react';
import { Stack, Text, Spinner } from '@guestyci/arc';
import { useOktaAuth } from '@okta/okta-react';
import t from '@guestyci/localize/t.macro';
import { getSecureAuthCookie } from '../../login/helpers';
import { saveUserPreferences } from 'utils/userPreferences';

import GuestyLogo from './guesty-logo-new1.svg';
import { utils } from 'utils';

const GoogleLoginHandler = () => {
  const { oktaAuth: authClient } = useOktaAuth();

  useEffect(() => {
    const initAuthentication = async () => {
      try {
        window.localStorage.removeItem('token');
        const { tokens } = await authClient.token.getWithoutPrompt();
        authClient.tokenManager.setTokens(tokens);
        await getSecureAuthCookie();
        console.log('Loading - Finished saving tokens.');
        if (tokens?.accessToken) {
          utils.saveUserData(tokens?.accessToken?.accessToken);
        }

        await saveUserPreferences({
          accessToken: tokens?.accessToken?.accessToken,
        });

        const currentUrl = new URL(window.location.href);
        const queryParams = currentUrl.search;
        const newUrl = queryParams ? `/${queryParams}` : '/';
        window.location.replace(newUrl);
      } catch (e) {
        console.error('Google handler failed with error', e);
      }
    };

    initAuthentication();
  }, [authClient]);

  return (
    <Stack direction="row" className="gst-min-h-screen gst-w-full">
      <Stack grow className="gst-h-full gst-pt-12 gst-pl-8">
        <Stack className="gst-mb-12">
          <img src={GuestyLogo} alt="Guesty Lite Logo" className="gst-w-32" />
        </Stack>
        <Stack align="center" justify="center" className="gst-mt-24 gst-p-4">
          <Spinner size="md" />
          <Text className="gst-mt-2">{t('Login in progress...')}</Text>
        </Stack>
      </Stack>
      <Stack className="gst-min-h-screen gst-w-1/3">
        <iframe
          className="gst-min-h-screen gst-w-full gst-border-0 gst-pl-1"
          src="https://www.guesty.com/promo-iframe-glite-signup/"
          title="Guesty Marketing Material2"
        />
      </Stack>
    </Stack>
  );
};

export default GoogleLoginHandler;
